module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/icon_day3-afdec3aab1fb51b167d958c4a22b71bc.svg";